import React from "react";
import Title from "../../../../Universal/Title.component";

const AllotmentHistoryCard = ({ profileClass, seatMatrixCode = [] }) => {
  return (
    <div
      style={{ border: "1.5px solid var(--greenColorLight)" }}
      className="w-full radius-6 flex-col align-start justify-start g-05 p-05"
    >
      <div className="w-full flex-row align-center justify-start g-05">
        <Title className={"color-black"}>Class:</Title>
        <Title style={{ color: "var(--greenColor)" }}>Class 5/A</Title>
      </div>
      <hr style={{ height: "0.5px" }} color="#d0d0d0" />

      {seatMatrixCode.length > 0 &&
        seatMatrixCode.map((matrixId, index) => {
          return (
            <div
              className="w-full flex-row align-center justify-start g-05"
              key={index}
            >
              <Title className={"color-black"}>Seat matrix code:</Title>
              <Title style={{ color: "var(--greenColor)" }}>{matrixId}</Title>
            </div>
          );
        })}
    </div>
  );
};

export default AllotmentHistoryCard;
